<template>
    <div>
        <b-row class="justify-content-center">
            <h5>{{ labels.title }}</h5>
        </b-row>
        <!-- <pre>{{ infoConstantes }}</pre> -->
        <!-- <pre>{{ this.infoConstantes.length == 0 ? 'INSERT' : 'EDIT'}}</pre> -->
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.constante}}1</h5>
            </b-col>
            <b-col cols="6" class="text-left" v-if="this.infoConstantes.length == 0">
                <input type="number" v-model="constanteUno" class="form-control">
            </b-col>
            <b-col cols="6" v-else>
                <input type="number" v-model="this.infoConstantes[0].constante_1" class="form-control" id="constUno">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.constante}}2</h5>
            </b-col>
            <b-col cols="6" class="text-left" v-if="this.infoConstantes.length == 0">
                <input type="number" v-model="constanteDos" class="form-control">
            </b-col>
            <b-col cols="6" v-else>
                <input type="number" v-model="this.infoConstantes[0].constante_2" class="form-control" id="constDos">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.constante}}3</h5>
            </b-col>
            <b-col cols="6" class="text-left" v-if="this.infoConstantes.length == 0">
                <input type="number" v-model="constanteTres" class="form-control">
            </b-col>
            <b-col cols="6" v-else>
                <input type="number" v-model="this.infoConstantes[0].constante_3" class="form-control" id="constTres">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.constante}}4</h5>
            </b-col>
            <b-col cols="6" class="text-left" v-if="this.infoConstantes.length == 0">
                <input type="number" v-model="constanteCuatro" class="form-control">
            </b-col>
            <b-col cols="6" v-else>
                <input type="number" v-model="this.infoConstantes[0].constante_4" class="form-control" id="constCuatro">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>Score</h5>
            </b-col>
            <b-col cols="6" class="text-left" v-if="this.infoConstantes.length == 0">
                <input type="number" v-model="score" class="form-control">
            </b-col>
            <b-col cols="6" v-else>
                <input type="number" v-model="this.infoConstantes[0].score" class="form-control" id="constScore">
            </b-col>
        </b-row>
        <md-dialog-actions class="mt-3">
            <div v-if="this.infoConstantes.length == 0">
                <md-button class="md-primary" @click="guardarConstante">{{ labels.save }}</md-button>
            </div>
            <div v-else>
                <md-button class="md-primary" @click="editConstante">{{ labels.edit }}</md-button>
            </div>
        </md-dialog-actions>
    </div>
</template>

<script>
import Constante from '../../../services/Constante';

export default {
    name : 'Constantes',
    props:['infoVigencia'],
    data: () => ({
        // vigencia : '',
        constanteUno : '',
        constanteDos : '',
        constanteTres : '',
        constanteCuatro : '',
        score : '',
        infoConstantes : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Constantes',
                    save : 'Guardar',
                    close : 'Cerrar',
                    vigencia : 'Vigencia',
                    constante : 'X',
                    edit : 'Editar'
                }
            }else{
                return {
                    title : 'Constants',
                    save : 'Save',
                    close : 'Close',
                    vigencia : 'Validity',
                    constante : 'X',
                    edit : 'edit'
                }
            }
        }
    },
    methods : {
        guardarConstante(){
            const dataForm = [
                // this.vigencia,
                this.constanteUno,
                this.constanteDos,
                this.constanteTres,
                this.constanteCuatro,
                this.score
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = [
                    {
                        'vigencia' : this.infoVigencia,
                        'constante' : this.constanteUno,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoVigencia,
                        'constante' : this.constanteDos,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoVigencia,
                        'constante' : this.constanteTres,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoVigencia,
                        'constante' : this.constanteCuatro,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoVigencia,
                        'score' : this.score,
                        'idUser' : this.$store.state.userId
                    }
                ]
                
                Constante.createConstante(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    }
                })
                .catch((err) => console.log(err))
            }
        },
        editConstante(){
            
            const dataForm = [
                document.getElementById('constUno').value,
                document.getElementById('constDos').value,
                document.getElementById('constTres').value,
                document.getElementById('constCuatro').value,
                document.getElementById('constScore').value
            ]
            // console.log(dataForm);
            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = [
                    {
                        'vigencia' : this.infoConstantes[0].vigencia,
                        'constante' : document.getElementById('constUno').value,
                        'idUser' : this.$store.state.userId,
                        'id' : this.infoConstantes[0].id
                    },
                    {
                        'vigencia' : this.infoConstantes[0].vigencia,
                        'constante' : document.getElementById('constDos').value,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoConstantes[0].vigencia,
                        'constante' : document.getElementById('constTres').value,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoConstantes[0].vigencia,
                        'constante' : document.getElementById('constCuatro').value,
                        'idUser' : this.$store.state.userId
                    },
                    {
                        'vigencia' : this.infoConstantes[0].vigencia,
                        'score' : document.getElementById('constScore').value,
                        'idUser' : this.$store.state.userId
                    }
                ]

                Constante.updateConstanteById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location.reload()                    
                    }
                })
                .catch((error) => console.log(error))
            }
        }
    },
    mounted(){

        Constante.getConstanteByVigencia(this.infoVigencia)
        .then((res) => {
            // console.log(res.data.constanteByVigencia);
            this.infoConstantes = res.data.constanteByVigencia
        })
        .catch((err) => {console.log(err)})
    }
}
</script>

<style>

</style>